// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ydvR","actionsCol":"EnrolledClinics_actionsCol__2tw5r"};